import Task from '../task';

/**
* Create the action
*/

const { thunk, request, success, error } = Task.store((data, fetch) => {

    // Prepare request
    let formData = new FormData();

    const fields = Object.keys(data);

    fields.map((field) => {

        formData.append(field, data[field]);
    });

    return fetch.post('/task', formData);
});

/**
* Export the components
*/

export { thunk as default };
export { request, success, error };